export default {
	state: {
		swipeStore:[],
		selected:{},
		index:0,
		currentOrgId:3,
    staffId:'',
	},
	mutations: {
    updateStaffId(state, id){
      state.staffId = id

    },
		updateSwipeStore(state, obj) {
			state.swipeStore = obj
		},
		updateSelected(state,obj){
			state.selected = obj
		},
		updateIndex(state,obj){
			console.log('vuex+++'+obj)
			state.index = obj
		},
		updateCurrent(state,obj){
			state.currentOrgId = obj
		}
	},
	getters:{
        getSwipeStore(state){
            return state.shoppingInfo
        }
    },
	actions: {
        swipeStoreAction:({commit}, obj)=>{
            console.log(obj, 'obj')
            commit("updateSwipeStore")
        }
	}
}



// WEBPACK FOOTER //
// ./src/components/swipeCode/swipeCode.js